import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import { type IGroupedLog, type ILog } from "src/interfaces/ChecklistLogbooks";
import { HomeLogbooks } from "src/pages/Home/Home.styled";
import { Flex } from "src/styled";

import { groupLogbooks } from "../CheckList.utils";
import { useChecklistsContext } from "../CheckListsContext";
import ChecklistLogbookCard from "./ChecklisLogbookCard";

const ChecklistLogbooks = () => {
  const navigate = useNavigate();
  const { logbooks, fetchChecklists } = useChecklistsContext();
  const [selectedLogbook, setSelectedLogbook] = useState<IGroupedLog | null>(
    null,
  );
  const groupedLogs = useMemo(
    () => groupLogbooks(logbooks as ILog[]),
    [logbooks],
  );

  const handleSelectLogbook = (name: string, groupLabel?: string) => {
    const listToLookIn = groupLabel
      ? groupedLogs.find(l => l.label === groupLabel)?.subSections
      : groupedLogs;

    if (!listToLookIn) return;
    const logbook = listToLookIn.find(l => l.label === name) as IGroupedLog;
    if (!logbook) return;

    if (logbook.subSections && logbook.subSections.length > 0)
      setSelectedLogbook(logbook);
    else navigate(`./logbook/${logbook.value}`);
  };

  const renderLogbooks = useCallback(() => {
    return selectedLogbook === null
      ? groupedLogs.map((l, i) => (
          <ChecklistLogbookCard
            key={`checklist-lb-1-${i}`}
            {...l}
            onClick={handleSelectLogbook}
          />
        ))
      : selectedLogbook.subSections.map((l, i) => (
          <ChecklistLogbookCard
            key={`checklist-lb-2-${i}`}
            {...l}
            onClick={v => handleSelectLogbook(v, selectedLogbook.label)}
          />
        ));
  }, [groupedLogs, selectedLogbook]);

  return (
    <Flex>
      {selectedLogbook && selectedLogbook?.subSections.length > 0 && (
        <Button onClick={() => setSelectedLogbook(null)}>Go back</Button>
      )}
      <HomeLogbooks>
        {(selectedLogbook === null || selectedLogbook.subSections.length > 0) &&
          renderLogbooks()}
      </HomeLogbooks>
    </Flex>
  );
};
export default ChecklistLogbooks;
